import React from 'react'
import type { SvgIconProps } from '@material-ui/core/SvgIcon'
import SvgIcon from '@material-ui/core/SvgIcon'

interface MapMarkerProps extends Omit<SvgIconProps, 'color'> {
  color: string
  eventNumber?: number
}

const MapMarker = ({ color, eventNumber, ...props }: MapMarkerProps) => (
  <SvgIcon viewBox="0 0 64 74" style={{ width: '64px', height: '74px' }} {...props}>
    <g filter="url(#markerShadow)" transform="translate(0, 8)">
      <mask id="markerMask" fill="white">
        <path d="M16 48C7.16 39.16 7.16 24.84 16 16C24.84 7.16 39.16 7.16 48 16C56.84 24.84 56.84 39.16 48 48L32 64L16 48Z" />
      </mask>
      <path
        d="M16 48C7.16 39.16 7.16 24.84 16 16C24.84 7.16 39.16 7.16 48 16C56.84 24.84 56.84 39.16 48 48L32 64L16 48Z"
        fill={color}
      />
      <path
        d="M32 64L30 66L32 68L34 66L32 64ZM48 48L46 46L30 62L32 64L34 66L50 50L48 48ZM32 64L34 62L18 46L16 48L14 50L30 66L32 64ZM48 16L46 18C54 26 54 38 46 46L48 48L50 50C60 40 60 24 50 14L48 16ZM16 16L18 18C26 10 38 10 46 18L48 16L50 14C40 4 24 4 14 14L16 16ZM16 16L14 14C4 24 4 40 14 50L16 48L18 46C10 38 10 26 18 18L16 16Z"
        fill="white"
        mask="url(#markerMask)"
      />
      {!eventNumber && <circle cx="32" cy="32" r="2" fill="white" />}
    </g>
    <defs>
      <filter id="markerShadow" x="-8" y="-6" width="80" height="80" filterUnits="userSpaceOnUse">
        <feOffset dy="2" />
        <feGaussianBlur stdDeviation="4" />
        <feBlend mode="normal" in="SourceGraphic" result="shape" />
      </filter>
    </defs>
    {eventNumber && (
      <text
        x="50%"
        y="58%"
        textAnchor="middle"
        dominantBaseline="middle"
        fill="white"
        fontSize="21px"
        fontWeight="bold"
      >
        {eventNumber}
      </text>
    )}
  </SvgIcon>
)

export default MapMarker
